import React, { useEffect, useState } from 'react'
import {
  Button,
  Stack,
  TextField,
  Box,
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@mui/material'
import { useParams } from 'react-router-dom'
import { ApiCreateStaffManager, ApiDeleteStaffManager, ApiGetStaffManager, ApiUpdateStaffManager } from '../../../apiService/Core/Apicall.tsx'
import { toast } from 'react-toastify'
import edit from '../Template Listing/editicon.png';
import deleteicon from '../Template Listing/deleteicon.png'

const StaffManager: React.FC = () => {
  const [StaffManagers, setStaffManagers] = useState<any>([])
  const adminId: any = localStorage.getItem('userId')
  const [managerName, setManagerName] = useState("")
  const [selectedStaff, setSelectedStaff] = useState<any>()
  const [open, setOpen] = useState(false)
  const { id } = useParams()

  const getStaffList = async () => {
    try {
      const data = `?offset=0&limit=100&venueId=${id}`
      const res = await ApiGetStaffManager(data)
      if (res?.data) {
        setStaffManagers(res?.data || [])
      }
    } catch (error: any) {
      toast.error("Error", error?.message)
    }
  }


  const CretaeStaff = async () => {
    if (managerName?.trim().length < 1) {
      window.alert("Please add Manager Name");
      return;
    }

    try {
      const data = {
        managerName: managerName?.trim(),
        venueId: id,
        ...(selectedStaff
          ? {
            modifiedBy: adminId,
            managerId: selectedStaff?.managerId,
          }
          : {
            createdBy: adminId,
          }),
      };

      const res = selectedStaff
        ? await ApiUpdateStaffManager(data)
        : await ApiCreateStaffManager(data);

      if (res?.data) {
        setStaffManagers(res?.data);
        setManagerName("");
        setOpen(false);
        setSelectedStaff(null);
        getStaffList()
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong");
    }
  };


  useEffect(() => {
    getStaffList()
  }, [])

  const handleDeleteStaff = async (managerId: number) => {
    const isConfirm = window.confirm("Are you sure you want to delete this staff?")
    if (isConfirm) {
      try {
        const data = `?managerId=${managerId}`
        const res = await ApiDeleteStaffManager(data)
        if(res?.success || res?.status){
          getStaffList()
        }
      } catch (error: any) {
        toast.error("Error", error?.message)
      }
    }
  }


  return (
    <div className='w-100 p-2'>
      <Box className='bg-light  border-10 p-2'>
        <Grid container className='p-2 mb-4 mt-3 align-items-center' gap={3}>
          <Grid size={{ xs: 12, md: "grow" }} order={{ xs: 1, md: 2 }}>
            <Typography className='fs-42 text-center'>Staff Member</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: "auto" }} order={{ xs: 3, md: 3 }}>
            <Stack>
              <Box
                onClick={() => setOpen(true)}
                className='table-row-background link-btn'
              >
                Add New Staff Member
              </Box>
            </Stack>
          </Grid>
        </Grid>

        {StaffManagers?.length > 0 ? (
          <Grid container spacing={2}>
          { StaffManagers?.map((item: any) => (
            <Grid size={4} key={item?.managerId} className='border d-flex align-items-center p-2 border-main border-10'>
              <Box flex='1'>
                <Typography variant='h6' className='fw-bold'>{item?.managerName}</Typography>
              </Box>
              <Box className='d-flex align-items-center'>
                <IconButton className='mr-0' onClick={() => { setSelectedStaff(item); setOpen(true) }}>
                  <Box component='img' height='32px' src={edit}></Box>
                </IconButton>
                <IconButton className='pl-0 ml-0' onClick={() => { handleDeleteStaff(item.managerId) }}>
                  <Box component='img' height='32px' src={deleteicon}></Box>
                </IconButton>
              </Box>
            </Grid>
          ))}
        </Grid>
        ): (<Typography variant='h6' className='text-center'>No Staff Member found</Typography>)}
      </Box>

      <Dialog open={open} className='p-2'>

        <DialogTitle className='m-0 mt-2 p-0' style={{ textAlign: "center" }}>
          {selectedStaff ? "Edit" : "Add"}Staff Member</DialogTitle>
        <DialogContent>
          <div className="form-group mb-0">
            <TextField
              label="Enter Manager Name"
              fullWidth
              size="small"
              sx={{ marginTop: "10px", boxShadow: 'none' }}
              value={managerName || selectedStaff?.managerName}
              onChange={(e) => setManagerName(e.target.value)}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
          <Button
            variant="outlined"
            sx={{ color: '#75724C', borderColor: '#75724C', width: '100%' }}
            onClick={() => { setOpen(false); setManagerName(""); setSelectedStaff(null) }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            className='table-row-background'
            sx={{ width: '100%' }}

            onClick={() => {
              CretaeStaff();
            }}
          >
            {selectedStaff ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default StaffManager
